import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { PublicAppElement } from './public-app-element';
import { PublicAppStyles } from './public-app-styles';

export class PublicAppFooter extends PublicAppElement {
    getYear() {
        return new Date().getFullYear();
    }

    render() {
        return html`
            <link rel="stylesheet" href="/css/global.css?v=${this.appVersion}">
            <div class="cb pb5"></div>
            <div class="footer text-wrap">
                <div class="re d-block d-sm-flex justify-content-center flex-wrap mb-2 pb-1">
                    <div class="d-flex justify-content-center">
                        <a href="https://www.socalgas.com" class="regFont">SoCalGas</a> <span class="pipe"></span> <a href="https://www.sdge.com" class="regFont">SDG&amp;E</a> <span class="pipe"></span> <a href="javascript:void(0);" onclick="PopWindowSystemRequirements();" class="regFont">System Requirements</a> <span class="pipe d-none d-sm-block"></span> 
                    </div>
                    <div class="d-flex justify-content-center">
                        <a href="https://www.socalgas.com/terms-and-conditions" class="regFont">Terms & Conditions</a> <span class="pipe"></span> <a href="#" onclick="showDisclaimer('/help/help_standard_disclaimer.html',' 550px',' Disclaimer');return false;">Disclaimer</a> <span class="pipe"></span> <a href="https://www.socalgas.com/privacy/" class="regFont">Privacy Policy</a> <span class="pipe"></span> <a href="javascript:void(0);" onclick="PopWindowContactUs();" class="regFont text-nowrap">Contact Us</a>
                    </div>
                </div>
                <div class="pb-2">Use of this web site and SoCalGas ENVOY<sup>&reg;</sup> is subject to Company Legal Terms and Conditions and Privacy, which are incorporated by reference herein.</div>
                <div class="pb-2">SoCalGas ENVOY<sup>&reg;</sup> is also governed by the current Tariff Rules applicable to such program filed with the CPUC. </div>
                <div>&copy; 1998-<span id="footer-copyright-end">${this.getYear()}</span> Southern California Gas Company. The trademarks used herein are the property of their respective owners. All rights reserved.</div>
            </div>

    `;
    }
}
declare global {
    interface HTMLElementTagNameMap {
        'public-app-footer': PublicAppFooter;
    }
}